import { TimeSlot } from '../network/api/types/compte/TimeSlot';

const toString2Digits = (x: number): string => x.toLocaleString('fr-FR', { minimumIntegerDigits: 2 });

export type SimpleTime = {
  hours: string
  minutes: string
};

export const timeSorter = (a: SimpleTime, b: SimpleTime): number => {
  if (a.hours !== b.hours) {
    return a.hours.localeCompare(b.hours);
  }
  return a.minutes.localeCompare(b.minutes);
};

export const getAllHours = (minutesStep: number): SimpleTime[] => {
  const h = 24;
  const m = 60;
  const ret = [];
  for (let i = 0; i < h; i += 1) {
    for (let j = 0; j < m; j += minutesStep) {
      ret.push({
        hours: toString2Digits(i),
        minutes: toString2Digits(j),
      });
    }
  }
  return ret;
};

export const toSimpleTimes = (timeslot: TimeSlot): SimpleTime[] => [
  {
    hours: toString2Digits(timeslot.startH),
    minutes: toString2Digits(timeslot.startM),
  },
  {
    hours: toString2Digits(timeslot.finishH),
    minutes: toString2Digits(timeslot.finishM),
  },
];

export const getNextTimeSlot = (timeSlot: TimeSlot, minutesStep: number): TimeSlot => {
  const nextMinutes = timeSlot.finishM + minutesStep;
  const nextNextMinutes = nextMinutes + minutesStep;
  const nextTimeSlot: TimeSlot = {
    startM: nextMinutes < 60 ? nextMinutes : nextMinutes - 60,
    startH: nextMinutes < 60 ? timeSlot.finishH : timeSlot.finishH + 1,
    finishM: nextNextMinutes < 60 ? nextNextMinutes : nextNextMinutes - 60,
    finishH: nextNextMinutes < 60 ? timeSlot.finishH : timeSlot.finishH + 1,
  };
  return nextTimeSlot.finishH < 24 ? nextTimeSlot : {};
};
